module.exports = __webpack_public_path__ + "assets/ac313e642602b96e74f728253d762ca1.png";